__turbopack_context__.v({
  "chips": "SizeBucketRefinement-module-scss-module__X314Ua__chips",
  "dropdown": "SizeBucketRefinement-module-scss-module__X314Ua__dropdown",
  "group": "SizeBucketRefinement-module-scss-module__X314Ua__group",
  "groupTitle": "SizeBucketRefinement-module-scss-module__X314Ua__groupTitle",
  "root": "SizeBucketRefinement-module-scss-module__X314Ua__root",
});
